export const NonBreakingSpace = '\u00A0';
